import React, {  useRef, useContext } from 'react';
import {  Button, Box, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import symptomHandler from '../../../../utilities/symptomHandler';
import RadioButton from '../../symptoms/Symptom Modal/radiobutton';
import CheckboxGroup from '../../symptoms/Symptom Modal/checkboxgroup';
import InputField from '../../symptoms/Symptom Modal/inputfield';
import TextArea from '../../symptoms/Symptom Modal/textarea';
import DropDown from '../../symptoms/Symptom Modal/dropdown';
import { SymptomDetailsContext } from '../../../../utilities/context.js'


function ExtraFormQuestions(props){
  
const { clinicQuestions, setClinicQuestions, setGenericQuestionsAsked} = useContext(SymptomDetailsContext) 
let initialValues= props.initialValues
const formValues=useRef()
const validationSchema=props.validationSchema
 
 const onSubmit=(values)=>{
  let newAnswers={}
  newAnswers= {...clinicQuestions}
 newAnswers[props.pathwayType][props.path]={...values} 
setClinicQuestions(newAnswers)
if (props.pathwayType === "rdc")
      {
      setGenericQuestionsAsked(true)
      }
  props.setFormSubmitted(true)
  props.setModalOpen(false)
   }

const onChange=(symptom,element)=>{
initialValues[symptom]=element} 

 let formQuestions=props.questions.map((symptom, index)=>{
    
      symptom["name"]=symptom.label.replaceAll(" ","_")


 switch(symptom["controlType"])
    {
      case "radio button":
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
       return (<Grid item sm={12} md ={5} lg={4} key={index}> <RadioButton  symptom={symptom}   key={0} onchange={onChange}/> </Grid>)

      case "number":
      return (<Grid item xs={6} sm={4} key={index}> <InputField type={"number"} symptom ={symptom} min={"0"} key={0} /> </Grid>)

      case "text":
       return (<Grid item xs={5} sm={3} key={index}> <InputField type={"text"} symptom ={symptom}  key={0} /> </Grid>)

      
      case "text area":
      return (<Grid item xs={12} sm={6} key={index}> <TextArea  symptom ={symptom}  key={0} /> </Grid>)
      
      case "dropdown": 
      symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "dropdown")
      return(<Grid item xs={5} sm={3} key={index}> <DropDown  symptom ={symptom}  key={0} /> </Grid>)

      case "checkbox group":
        let gridSize = 4
        if (symptom.options.length >5)
          {gridSize = 8} 
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
        return (<Grid item  xs={gridSize} key={index}> <CheckboxGroup symptom={symptom}  key={0} /> </Grid>)

        case "checkbox group extra wide":
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
        return (<Grid item  xs={12} key={index}> <CheckboxGroup symptom={symptom}  key={0} /> </Grid>)


      case "date":
      return (<Grid item xs={5} sm={4} key={index}> <InputField type={"date"} symptom ={symptom}  key={0} /> </Grid>)

      default:{return(<></>)}
 }})


return(

        <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        innerRef={formValues}
        >

       <Form>
           
        <Box>
        <Grid container >
        {formQuestions}
         <Button sx={{ m: 1 }} variant='contained' size="small" type='submit'>Request Clinic Appointment</Button>
       </Grid> 
       </Box>
       
        </Form>
      </Formik>
)

}
export default ExtraFormQuestions